import styled from 'styled-components';

export const Sections = styled.div``;

export const Section = styled.div``;

export const CompletedList = styled.div`
  padding: ${({ theme }) => `0 ${theme.spacing(6)}`};
`;
